// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(() => {
//     let wsForm = document.querySelector("#wsg-signup");

//     if (!wsForm) {
//       console.log("Form not found.");
//       return;
//     }

//     console.log("Form is", wsForm);
//     let button = wsForm.querySelector("#wsg-submit");

//     if (button) {
//       console.log("Submit button found:", button);

//       // Clone the button to remove all existing event listeners
//       let newButton = button.cloneNode(true);
//       button.parentNode.replaceChild(newButton, button);
//       console.log("All event listeners removed from #wsg-submit");

//       // Add our custom event to capture form data and trigger the original event
//       newButton.addEventListener("click", function (event) {
//         event.preventDefault(); // Prevent default action temporarily

//         let formData = new FormData(wsForm);
//         let dataObject = {};

//         formData.forEach((value, key) => {
//           dataObject[key] = value;
//         });

//         console.log("Captured Form Data:", dataObject);

//          localStorage.setItem("wsgFormData", JSON.stringify(dataObject));

//         // Now trigger the original click event manually
//         let originalClickEvent = new Event("click", { bubbles: true, cancelable: true });
//         button.dispatchEvent(originalClickEvent);
//       });

//       console.log("Custom click event added, and original event will be triggered.");
//     }
    
//   }, 2000);
// });




// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(() => {
//     let wsForm = document.querySelector("#wsg-signup");

//     if (!wsForm) {
//       console.log("Form not found.");
//       return;
//     }
//     let removedOptions = []; 
//     let countryOptions = wsForm.querySelector("#wsg-form-country");
//       const options = Array.from(countryOptions.options);
//       options.forEach(option => {
//     if (option.value.includes('-')) {
//       removedOptions.push(option);
//       option.remove(); // Removes the option from the DOM
//     }
//   });

//   // console.log("Remaining options:", Array.from(countryOptions.options));

//       removedOptions.forEach(option => {
//          if (!option.value.includes('-')) {
//     countryOptions.appendChild(option); // Add it back only if no hyphen
//   }
//     // countryOptions.appendChild(option); // Add it back
//   });

    
//     let button = wsForm.querySelector("#wsg-submit");

//     if (button) {
//       let newButton = button.cloneNode(true);
//       button.parentNode.replaceChild(newButton, button);

//       newButton.addEventListener("click", async function (event) {
//         event.preventDefault();

//         let formData = new FormData(wsForm);
//         let dataObject = {};

//         formData.forEach((value, key) => {
//           dataObject[key] = value;
//         });

//          console.log("Captured Form Data:", dataObject);
//         if(dataObject.customer_first && dataObject.customer_last && dataObject.customer_email && dataObject.phone && dataObject.company && dataObject.notes) {
//           try {
//           let response = await fetch("https://hook.us2.make.com/dpqarezdk58nppphichrcivoub5j6nqd", {
            
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json"
//             },
//             body: JSON.stringify(dataObject)
//           });

//           if (response.ok) {

//             console.log("WSG form data sent successfully.");
//           } else {
//             console.error("Failed to send form data.");
//           }
//         } catch (error) {
//           console.error("Error sending form data:", error);
//         }
//         }
//         // localStorage.setItem("wsgFormData", JSON.stringify(dataObject));
        
//         // try {
//         //   let response = await fetch("https://hook.us2.make.com/dpqarezdk58nppphichrcivoub5j6nqd", {
            
//         //     method: "POST",
//         //     headers: {
//         //       "Content-Type": "application/json"
//         //     },
//         //     body: JSON.stringify(dataObject)
//         //   });

//         //   if (response.ok) {
//         //     console.log("WSG form data sent successfully.");
//         //   } else {
//         //     console.error("Failed to send form data.");
//         //   }
//         // } catch (error) {
//         //   console.error("Error sending form data:", error);
//         // }
        

//         let originalClickEvent = new Event("click", { bubbles: true, cancelable: true });
//         button.dispatchEvent(originalClickEvent);
//       });

//       console.log("Custom click event added, and original event will be triggered.");
//     }
    
//   }, 5000);
// });







document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    let wsForm = document.querySelector("#wsg-signup");

    if (!wsForm) {
      console.log("Form not found.");
      return;
    }

    let removedOptions = []; 
    let countryOptions = wsForm.querySelector("#wsg-form-country");

    if (countryOptions) {
      const options = Array.from(countryOptions.options);

      
      options.forEach(option => {
        if (option.value.includes('-')) {
          removedOptions.push(option);
          option.remove();
        }
      });

   
      removedOptions.forEach(option => {
        if (!option.value.includes('-')) {
          countryOptions.appendChild(option);
        }
      });
    }

    let button = wsForm.querySelector("#wsg-submit");

    if (button) {
      // Clone button to REMOVE existing JS listeners
      let newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", async function (event) {
        event.preventDefault(); // pause default submit

        // Capture form data
        let formData = new FormData(wsForm);
        let dataObject = {};

        formData.forEach((value, key) => {
          dataObject[key] = value;
        });

        // Validate required fields
        let requiredFields = ["customer_first", "customer_last", "customer_email", "phone", "company", "notes"];
        let isValid = requiredFields.every(field => dataObject[field]);

        if (isValid) {
          try {
            let response = await fetch("https://hook.us2.make.com/dpqarezdk58nppphichrcivoub5j6nqd", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(dataObject)
            });

            if (response.ok) {
              console.log("WSG form data sent successfully.");
            } else {
              console.error("Failed to send form data.");
            }
          } catch (error) {
            console.error("Error sending form data:", error);
          }
        }

        // ---- IMPORTANT ----
        // TRIGGER THE ORIGINAL FORM SUBMISSION
        wsForm.submit();
      });

      console.log("Custom click listener added, Make.com webhook + original login working.");
    }

  }, 4000);
});
